//Only pass array of objects as "args"
export function orderBy(arg: any[], separator: string) {
  const myData = ([] as any[])
    .concat(arg)
    .sort(function (a, b) {
      if (getValue(a, separator) > getValue(b, separator)) {
        return 1;
      }
      if (getValue(a, separator) < getValue(b, separator)) {
        return -1;
      }
      return 0;
    })
    .map((element) => {
      return element;
    });
  return myData;
}

function getValue(result: any, field: string) {
  let value: any;
  const keys = field.split(".");
  keys.forEach((key) => {
    if (value) {
      value = value[key];
    } else {
      value = result[key];
    }
  });
  return value;
}
